import {Modal} from "react-bootstrap";
import React, {useState} from "react";
import {detectSource} from "../utils/sourceDetection";
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3';

function SaveEmailQuote(props) {
    let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const source = detectSource();
  const isAAPath = source === 'AA' || source === 'AA_MEMBER';
  const isVTNZPath = source === 'VTNZ';
  const baseUrl = window.location.origin;
  const {executeRecaptcha} = useGoogleReCaptcha();

  const handleClose = () => {
    props.setShowEmailPopup(false);
    setSuccess(false);
    };



    const sendEmail = async () => {
        let isError = false;
        const newErrors = {}
        if (!email || email === '') {
            newErrors.email = 'Please enter a valid email address'
            isError = true;
        } else if (email.length > 100) {
            newErrors.email = 'Email address too long.'
            isError = true;
        } else {
            if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
                newErrors.email = 'Is invalid';
                isError = true;
            }
        }

        if(!isError) {
            let recaptchaToken = null;
            if (props.inputValues.mbiRecaptchaEnabled && executeRecaptcha) {
                recaptchaToken = await executeRecaptcha('email_quote');
            }

            const prospectData = {
                id: props.inputValues.id,
                email: email,
                source: source,
                recaptchaResponse: recaptchaToken
            };

            fetch(`${url}/campaign/policy-renewal/prospect/email-quote`, {
                method: 'POST',
                mode: "cors",
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": 'By-Pass-Auth-Create-Prospect'
                },
                body: JSON.stringify(prospectData)
            })
              .then(async (response) => {
                if (response.status === 200) {
                  setSuccess(true);
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: 'mbiAutosureEvent',
                      category: 'Email My Quote Submit',
                      status: 'Success',
                      virtualUrl: `${baseUrl}/mbi/step2`,
                      pageTitle: 'Choose Your Cover',
                    });
                } else {
                  setSuccess(false);
                  props.setShowEmailPopup(false);
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: 'mbiAutosureEvent',
                    category: 'Email My Quote Submit',
                    status: 'Fail',
                    virtualUrl: `${baseUrl}/mbi/step2`,
                    pageTitle: 'Choose Your Cover',
                  });
                }
              })
                .catch((e) => {
                  setSuccess(false);
                  props.setShowEmailPopup(false);
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: 'mbiAutosureEvent',
                    category: 'Email My Quote Submit',
                    status: 'Fail',
                    virtualUrl: `${baseUrl}/mbi/step2`,
                    pageTitle: 'Choose Your Cover',
                  });
                });
        }
        setErrors(newErrors);
    };


    return (
        <>
            <Modal
                show={props.showEmailPopup}
                onHide={handleClose}

                backdrop="static"
                size="lg"
                keyboard={false}
            >
                <Modal.Header closeButton style={{backgroundColor: "slategrey"}}>
                    <Modal.Title className="mediumTextStyles"><span
                        style={{color: 'White'}}>Save my quote for later</span> </Modal.Title>
                </Modal.Header>

                <Modal.Body className="regularTextStyles">
                    <p style={{textAlign: "center"}}>
                        Please enter your email address and we’ll send you your quote, which will be valid
                        until {props.inputValues.quoteExpiry}.
                    </p>
                    <p style={{textAlign: "center"}}>
                        <input  type="textbox" placeholder="e.g. jane.smith@example.com" size={30} value={email} onChange={(e) => setEmail(e.target.value)}/>
                        <div className="regularErrorStyle">
                            {errors.email}
                        </div>
                    </p>

                </Modal.Body>
                <Modal.Footer style={{justifyContent: "center"}}>
                  {!success &&
                  <button style={{
                    color: 'white',
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                    borderRadius: 6,
                    paddingTop: 13,
                    paddingBottom: 13,
                    overflow: 'hidden',
                    border: '1px white solid',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'inline-flex',
                    width: "100%",
                    maxWidth: "200px",
                    backgroundColor: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#1851a3'
                  }}
                          onClick={sendEmail}>
                        Save and email my quote
                  </button>}
                  {
                    success &&
                    <div>
                      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="Check circle">
                          <path
                            id="Icon"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.5 18.6C14.9183 18.6 18.5 15.0182 18.5 10.6C18.5 6.18168 14.9183 2.59996 10.5 2.59996C6.08172 2.59996 2.5 6.18168 2.5 10.6C2.5 15.0182 6.08172 18.6 10.5 18.6ZM14.2071 9.30707C14.5976 8.91654 14.5976 8.28338 14.2071 7.89285C13.8166 7.50233 13.1834 7.50233 12.7929 7.89285L9.5 11.1857L8.20711 9.89285C7.81658 9.50233 7.18342 9.50233 6.79289 9.89285C6.40237 10.2834 6.40237 10.9165 6.79289 11.3071L8.79289 13.3071C9.18342 13.6976 9.81658 13.6976 10.2071 13.3071L14.2071 9.30707Z"
                            fill="#54B444"
                          />
                        </g>
                      </svg>
                      Email sent!</div>
                  }
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default SaveEmailQuote;
